import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Publish a folder (ESL Folders account only; makes it visible under Ellii Folders)
 * @param {Object} config
 * @param {number} config.id - The folder ID
 * @param {string} config.publishedAt - ISO datetime string to for when the folder was published
 */
const publishFolder = ({ id, publishedAt }) =>
  xhr({
    url: `${foldersEndpoint}/${id}`,
    method: 'PUT',
    data: {
      folder: {
        esl_published_at: publishedAt,
      },
    },
  })

export default publishFolder
